import { CookieManager } from "src/fe-common/helpers/cookieManager";
import { getAppAbsoluteUrl } from 'src/helpers/appOriginUrls';
import { setFrontendContext } from "fe-shared-lib/src/observability";
import { FirebaseAnalytics } from "../App/firebaseAnalytics";
import { FirebaseTokenRegisterSubject } from "../App/subject/firebaseNotificationManager.subject";
import { LoginStatus } from "../networked-shared-interfaces/constants/login-status";

export class UserUtility {

	public static getUserDetails(): {
		userId: string,
		name: string,
		image: string,
		title: string,
		email: string
	} {
		let details = localStorage.getItem('user');
		if (!details)
			return undefined;
		return JSON.parse(details);
	}
	public static getMattermostDetails(): {
		loginId?: string,
		password?: string,
	} {
		let details = localStorage.getItem('mattermost');
		if (!details)
			return {};
		try {
			return JSON.parse(details);
		} catch (ex) {
			return {}
		}
	}


	public static setMessageUser(val: {
		userId: string,
		name: string,
	}) {
		localStorage.setItem('messageUser', JSON.stringify(val));
	}

	public static getSelectedCommunityId(): string {
		let community = localStorage.getItem('selected_community');
		return community
	}

	/** Display name from last community token response (see useCommunitySwitch). */
	public static getSelectedCommunityName(): string | undefined {
		const name = localStorage.getItem('communityName');
		return name || undefined;
	}

	public static loginSuccess(response, communityId): any {
		const { user, community, mattermost, status, sessionToken } = response;

		FirebaseAnalytics.getInstance().setUserID(response.user.userId)

		localStorage.setItem('user', JSON.stringify(user));
		localStorage.setItem('status', JSON.stringify(status));
		CookieManager.setSessionToken(sessionToken)
		if (community.token) {
			CookieManager.setReadableId(community.readableId)
			CookieManager.setCommunityToken(community.token)
		}
		localStorage.setItem('mattermost', JSON.stringify(mattermost));

		setFrontendContext({
			user: { id: user.userId, email: user.email, name: user.name },
			communityId: communityId || response.communityDetails?.communityId,
			communityName: response.communityDetails?.name,
		});

		let redirct_page = '/home';
		switch (status) {
			case LoginStatus.NormalUser:
				localStorage.setItem('selected_community', communityId ? communityId : response.communityDetails.communityId);
				CookieManager.setCookie(`selected_community_${response.user.userId}`, communityId ? communityId : response.communityDetails.communityId, CookieManager.calculateDomain())
				FirebaseTokenRegisterSubject.next(null);
				redirct_page = '/home';
				break;
			case LoginStatus.CommunityMissing:
				localStorage.setItem('onboardToken', community.onboardToken);
				redirct_page = '/explore';
				break;
			case LoginStatus.ProfileMissing:
				localStorage.setItem('selected_community', communityId ? communityId : response.communityDetails.communityId);
				CookieManager.setCookie(`selected_community_${response.user.userId}`, communityId ? communityId : response.communityDetails.communityId, CookieManager.calculateDomain())
				redirct_page = '/home';
				break;
			case LoginStatus.ProfileNotActivated:
				redirct_page = undefined
				break;
			case LoginStatus.RedirectToCommunity:
				if (response.communityDetails) {
					localStorage.setItem('selected_community', communityId ? communityId : response.communityDetails.communityId);
					CookieManager.setCookie(`selected_community_${response.user.userId}`, communityId ? communityId : response.communityDetails.communityId, CookieManager.calculateDomain())
				}
				if (response.redirectDetails && !communityId) {
					if (response.redirectDetails.shouldRedirectExplore && response.redirectDetails.communityId) {
						this.clearCommunitySelection()
						redirct_page = getAppAbsoluteUrl(`/community/${response.redirectDetails.communityId}`);
					} else
						redirct_page = `/home`;
				}

				break;
			case LoginStatus.CommunityWaiting:
			default:
				redirct_page = '/home';
				break;
		}

		return redirct_page;
	}
	static clearCommunitySelection = () => {
		localStorage.removeItem("selected_community")
		localStorage.removeItem("selected_readable_id")
		CookieManager.removeCommunityToken()
		localStorage.removeItem("selected_image")
		localStorage.removeItem("communityDetails")
	}


	public static isCurrentUser(userId: string): boolean {
		const loginUserId = JSON.parse(localStorage.getItem('user')).userId;
		return userId === loginUserId;
	}
}